import DealerError from './DealerError.js'

export class CallMeNowDealerError extends DealerError {}
